@if(safeDescription || product.getAttr('product_features')){
<div class="cms-html">
    <ng-container [ngTemplateOutlet]="hideUpItemTemplate"
                  [ngTemplateOutletContext]="{title: 'Description', toggleId: 'description', content: descriptionTemplate, borderTop: client.isS || client.isM}" />
</div>
}
@if(technicalInformation){
<ng-container [ngTemplateOutlet]="hideUpItemTemplate"
              [ngTemplateOutletContext]="{title: 'Technical Information', toggleId: 'technical', content: technicalTemplate}" />
}
@if(documents?.length){
<ng-container [ngTemplateOutlet]="hideUpItemTemplate"
              [ngTemplateOutletContext]="{title: 'Documents', toggleId: 'documents', content: documentsTemplate}" />
}

<ng-template #hideUpItemTemplate
             let-title="title"
             let-toggleId="toggleId"
             let-content="content"
             let-borderTop="borderTop">
    <div class="b-b b-col-5"
         [class.b-t]="borderTop">
        <button class="w-12 flex flex-justify-between flex-middle"
                (click)="toggleService.toggle([uid, toggleId])">
            <span class="block h3 s1-s s1-m p-t-5 p-b">{{title | translate}}</span>
            <i [toggleClass]="'!icon-chevron-down icon-chevron-up'"
               [toggleClassBy]="toggleService.getState([uid, toggleId])"></i>
        </button>
        <hide-up [open]="toggleService.getState([uid, toggleId])">
            <div class="p-b-5 p-b-4-s p-b-4-m">
                <ng-container [ngTemplateOutlet]="content" />
            </div>
        </hide-up>
    </div>
</ng-template>


<ng-template #descriptionTemplate>
    <div #descriptionBody
         class="_description"
         [id]="descriptionBodyId"
         [class.is-expanded]="descriptionExpanded()"
         [class.is-animating]="descriptionAnimating()"
         [class.is-faded]="descriptionOverflows() && !descriptionExpanded()">
        <!-- plain wrapper: the copy carries `cms-html` and `innerHTML`, so the badges have to be
             siblings of it rather than children, and the wrapper is what gets measured -->
        <div #descriptionContent>
            <div class="cms-html"
                 [innerHTML]="safeDescription"></div>
            @if(product.getAttr('product_features')){
            <div class="bg-col-52 p-a-2 w-12 flex flex-middle flex-wrap _features m-t">
                @for(feature of product.getAttr('product_features') || []; track feature){
                <div class="flex flex-middle">
                    <swatch class="inline-block m-r-2"
                            style="width:20px"
                            [attributeCode]="'product_features'"
                            [value]="feature" />
                    <span class="s1">{{feature | optionLabel : 'product_features'}}</span>
                </div>
                }
            </div>
            }
        </div>
    </div>
    <!-- always rendered so server and client markup match; the class hides it when
         the copy already fits -->
    <button type="button"
            class="_description-toggle s1 link col-11 m-t-2"
            [class.is-hidden]="!descriptionOverflows()"
            [attr.aria-expanded]="descriptionExpanded()"
            [attr.aria-controls]="descriptionBodyId"
            (click)="toggleDescription()">{{(descriptionExpanded() ? 'Show less' : 'Read more') | translate}}</button>
</ng-template>

<ng-template #technicalTemplate>
    <ul [grid]="[1, 1, 2, 2][app.client.sizeId]"
        [gridColumnGap]="'32px'"
        [gridRowGap]="'16px'">
        @for(column of technicalInformation; track $index){
        <!-- the grid column wrapper is an <li> with a nested <ul> so the list
             items keep a list parent; global normalize zeroes list padding,
             margin and markers, so this is structural only -->
        <li>
            <ul>
                @for(item of column; track $index){
                <li class="_technical-item flex w-12 flex-column-s flex-column-m"
                    [class.m-t]="!$first">
                    <span class="flex-grow w-12 _technical-item-label-container"
                          style="max-width: 125px">
                        <span class="_technical-item-label block s1">{{item.label}}:</span>
                    </span>
                    <div>
                        @for(value of item.valuesLabels; track $index){
                        <span class="p1">{{value}}{{$last ? '' : ', '}}</span>
                        }
                    </div>
                </li>
                }
            </ul>
        </li>
        }
    </ul>
</ng-template>

<ng-template #documentsTemplate>
    <ul [grid]="[1, 1, 2, 2][app.client.sizeId]"
        [gridColumnGap]="'16px'"
        [gridRowGap]="'16px'"
        class="p-b-5 p-b-4-s p-b-4-m">
        @for(document of documents; track document.file){
        <li>
            <span class="flex"
                  style="gap:16px">
                <i class="icon-doc"
                   style="font-size:24px"></i>
                <button class="link"
                        (click)="download(document)">
                    <span class="p1 link">{{document.label}}</span>
                </button>
            </span>
        </li>
        }

    </ul>
</ng-template>